import './style.css';

export const Loading = () => {
  return (
    <div className="loading inset-0 flex items-center justify-center z-50">
      <div className="loading-spinner">
        <div className="loading-spinner__circle"></div>
      </div>
    </div>
  );
};
